import PageAutoral from './components/PageAutoral';

export default function App() {
  return <PageAutoral />;
}
